import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <Navbar />
      <div className="about-container">
        <div className="about-hero">
          <h1>About <span className="highlight">Loungie</span></h1>
          <p className="about-subtitle">
            Where exceptional talent meets elite opportunities
          </p>
        </div>

        <div className="about-content">
          <section className="about-section">
            <h2>Our Mission</h2>
            <p>
              Loungie is a premium career platform exclusively for ambitious students seeking 
              extraordinary opportunities. We curate roles from India's most innovative 
              companies and connect them with exceptional talent.
            </p>
          </section>

          <section className="about-section">
            <h2 lassName="about-section">Why Loungie?</h2>
            <div className="features-grid">
              <div className="feature">
                <div className="feature-icon">🎯</div>
                <h3>Curated Excellence</h3>
                <p>Every opportunity is handpicked to match your ambition</p>
              </div>
              <div className="feature">
                <div className="feature-icon">⚡</div>
                <h3>Real-time Alerts</h3>
                <p>Get notified instantly when dream roles become available</p>
              </div>
              <div className="feature">
                <div className="feature-icon">🏆</div>
                <h3>Premium Network</h3>
                <p>Access to India's most coveted positions</p>
              </div>
              <div className="feature">
                <div className="feature-icon">🚀</div>
                <h3>Career Growth</h3>
                <p>Build your future with the best companies</p>
              </div>
              <div className="feature">
                <div className="feature-icon">🛡</div>
                <h3>No Fake or Duplicate Jobs</h3>
                <p>We filter out duplicate and outdated listings.</p>
              </div>
              <div className="feature">
                <div className="feature-icon">🔎</div>
                <h3>Smart Job Filtering</h3>
                <p>Quickly find the right jobs by filtering based on role, location and salary.</p>
              </div>
              
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
